/* Tysk katalog for locale-advisor-costs-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'adv.cost.review': 'Genauer ansehen',
  'adv.cost.moreTitle': 'Weitere Möglichkeiten',
  'adv.cost.observedValue': 'Beobachteter Wert',
  'adv.cost.invoiceBasis': 'Abrechnungsgrundlage',
  'adv.cost.draftValue': 'Entwurfswert',
  'adv.cost.possibleCount': 'Mögliche Duplikate',
  'adv.cost.purchaseShare': 'Einkaufsanteil',
  'adv.cost.givenDiscount': 'Gewährter Rabatt',
  'adv.cost.unbilledNote': 'Abrechnungsgrundlage, keine gebuchten Erlöse',
  'adv.cost.draftNote': 'Entwurfswert, keine gebuchten Erlöse',
  'adv.cost.acceptedNote': 'Angenommene Angebote ohne verknüpfte Rechnung',
  'adv.cost.duplicateNote': 'Mögliche Duplikate, die geprüft werden müssen',
  'adv.cost.supplierNote': 'Einkaufsvolumen, das eine Verhandlungsgrundlage bieten kann',
  'adv.cost.discountTitle': 'Gewährte Rabatte durchgehen',
  'adv.cost.discountNote': 'Tatsächlich gewährter Rabatt, keine berechnete Einsparung',
  'adv.cost.voucherNote': 'Dokumentation, die nachverfolgt werden muss; keine berechnete Einsparung',
  'adv.cost.followUp': 'Zur Nachverfolgung',
  'adv.cost.increaseToReview': 'Zu prüfender Anstieg',
  'adv.cost.fixedTitle': 'Gebuchte Fixkosten',
  'adv.cost.tryAdjustment': 'Anpassung ausprobieren',
  'adv.cost.fixedDetail': 'Durchschnitt pro Monat, basierend auf {months} vollen Monaten',
  'adv.cost.otherTitle': 'Größte sonstige Kostenkonten',
  'adv.cost.otherIntro': 'Der Anteil zeigt die gebuchten Kosten im Verhältnis zum Umsatz im gewählten Jahr. Er ist keine Sparschätzung, und das Konto wird nicht automatisch als variabel eingestuft.',
  'adv.cost.otherDetail': '{amount} im gewählten Jahr gebucht',
  'adv.cost.ofRevenue': 'des Umsatzes',
  'adv.cost.noRevenueShare': 'Anteil nicht berechnet',
  'adv.cost.sub': 'Größte gebuchte Kostenkonten und Veränderung zum Vorjahr',
  'adv.cost.subPeriod': 'Größte gebuchte Kostenkonten und Veränderung zum Vorjahreszeitraum',
  'adv.cost.help': 'Die Konten stammen aus der Gewinn- und Verlustrechnung für das gewählte Jahr. Die Balken zeigen den gebuchten Betrag je Konto. Eine Veränderung wird nur angezeigt, wenn dasselbe Konto im Vorjahr einen positiven Betrag hat.',
  'adv.cost.helpPeriod': 'Die Konten stammen aus der Gewinn- und Verlustrechnung bis einschließlich des laufenden Monats. Die Balken zeigen den gebuchten Betrag je Konto. Die Veränderung wird mit dem Vorjahreszeitraum verglichen, wenn das Konto einen positiven Betrag hatte.',
  'adv.cost.rowHelp': 'Auf dem Konto gebucht: {amount} im gewählten Jahr. Veränderung zum Vorjahr: {change}.',
  'adv.cost.noComparison': 'Keine Vorjahreswerte',
  'adv.cost.emptyText': 'Keine gebuchten Kostenkonten im gewählten Jahr.',
  'adv.cost.flagText': '{name} ist im Vergleich zum Vorjahr deutlich gestiegen. Prüfe, ob die Veränderung geplant war, und sieh dir die Buchungen auf dem Konto an.',
  'adv.why.costSub': 'Kostenkonten, die im Vergleich zum Vorjahr deutlich gestiegen sind',
});
